import AuthReducer from "./AuthReducers";
import UserReducer from "./UserReducers";
export default {
    AuthReducer,
    UserReducer
};